import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@semcore/flex-box";
import { Paper } from "@mui/material";

import googleImg from "../../Assets/google-analytics/google.png";
import { getDomainNameAndLang } from "../../../helperJs/getCountryFlag";
import ProjectList from "../../share/dropdown-menu/ProjectList";
import { POST_AIOPPORTUNITY } from "../../../services/constants";
import FallbackLoader from "../../share/components/FallbackLoader";
import AddProjectStore from "../../../store/AddProjectStore";
import MenuListDropdown from "../../share/components/menulist.component";
import { useTranslation } from "react-i18next";

import ConnectGoogleImg from "../../Assets/connect_google.gif";
import html2pdf from "html2pdf.js";

const Opportunities = () => {
  const navigate = useNavigate();
  const containRef = useRef(null);
  const { t } = useTranslation();
  const [opportunities, setOpportunities] = useState({
    data: [],
    error: "",
    loading: true,
  });

  const websiteurl = useSelector((state) => state.websiteurl);
  const domain = getDomainNameAndLang(websiteurl);

  const { showNotification } = AddProjectStore((state) => state);

  // useEffect(() => {
  //   const handleClick = (event) => {
  //     const element = event.target;
  //     console.log("Clicked:", element);
  //   };

  //   document.addEventListener("click", handleClick);

  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, []);

  useEffect(() => {
    const InlineStyleTags = () => {
      const container = document.getElementById("content-to-download");
      if (!container) return;
      const links = document.querySelectorAll(".ai-opportunity-editor a");
      links.forEach((link) => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      });
      // Find all <style> tags inside the container
      const styleTags = container.querySelectorAll("style");
      styleTags.forEach((tag) => tag.remove());
    };

    InlineStyleTags();
  }, [opportunities.data]);

  useEffect(() => {
    const email = localStorage.getItem("admin_mail");
    const handleAIOppertunity = async () => {
      const getConfig = {
        email: email,
        domain_name: domain?.domain,
      };
      if (!getConfig.email || !getConfig.domain_name) return;
      setOpportunities({
        data: [],
        loading: true,
        error: "",
      });
      try {
        const resp = await axios.post(POST_AIOPPORTUNITY(getConfig));
        if (resp.data.status == 200) {
          setOpportunities({
            data: resp.data.data,
            loading: false,
            error: "",
          });
        } else {
          setOpportunities({
            data: [],
            error: resp.data.msg,
            loading: false,
          });
          showNotification({
            message: resp.data.msg,
            severity: "error",
          });
        }
      } catch (error) {
        setOpportunities({
          data: [],
          loading: false,
          error: "",
        });
        showNotification({
          message: "Unexpected error occurred 🤷‍♂️",
          severity: "error",
        });
      }
    };
    handleAIOppertunity();
  }, [domain?.domain]);

  const handleGoogleConnect = () => {
    navigate("/google-data");
  };

  const exportAsPDF = async () => {
    if (opportunities.data?.length === 0)
      return console.error("content not available for PDF");
    const element = document.getElementById("content-to-download");
    html2pdf()
      .from(element)
      .set({
        margin: [10, 10, 15, 10],
        filename: "SEO-Opportunities.pdf",
        html2canvas: { scale: 1.5 }, // Higher scale for better quality
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      })
      .save()
      .catch((error) => {
        console.error("Error generating simple PDF:", error);
      });
  };

  const exportAsDoc = () => {
    if (opportunities.data?.length === 0)
      return console.error("content not available for DOC");
    const content = document.getElementById("content-to-download").innerHTML;
    const blob = new Blob(
      [
        `<html><head><meta charset='utf-8'></head><body>${content}</body></html>`,
      ],
      {
        type: "application/msword",
      }
    );

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `SEO-Opportunities.doc`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dataList = {
    title: "Export",
    list: [
      <button
        className="btn_new_tr_bg"
        onClick={exportAsDoc}
      >
        <i
          className="fa-regular fa-file-lines"
          style={{ paddingRight: "10px" }}
        ></i>
        DOC
      </button>,

      <button
        className="btn_new_tr_bg"
        onClick={exportAsPDF}
      >
        <i
          className="fa-regular fa-file-lines"
          style={{ paddingRight: "10px" }}
        ></i>
        PDF
      </button>,
    ],
  };

  return (
    <main className="main-pd m-auto opportunity-container">
      <h5 className="">{t("opportunities.title")}</h5>
      {/* <p>{t("opportunities.des")}</p> */}
      <Box className="d-flex align-items-center flex-wrap gap-2">
        <Box wMax={"380px"} wMin={"300px"}>
          <ProjectList />
        </Box>
        {opportunities?.data?.length === 0 ? null : (
          <Box className="ms-auto">
            <MenuListDropdown data={dataList} />
          </Box>
        )}
      </Box>
      {opportunities.loading ? (
        <FallbackLoader />
      ) : opportunities.data.length === 0 ? (
        <Box wMax={"80%"} m={"10px auto"} hMin={"600px"}>
          <div className="view-google-data d-flex flex-column justify-content-center align-items-center overflow-x-auto">
            <div className="text-center">
              <img
                src={ConnectGoogleImg}
                alt="con-google"
                style={{
                  maxWidth: "350px",
                  marginBottom: "20px",
                  objectFit: "contain",
                }}
              />
              <p className="heading-large font-light-bold"> </p>
              <b>{t("opportunities.highlight")}</b>
              <p className="mb-0">{t("opportunities.para")}</p>
            </div>
            <div className="analy-gol mt-3 d-flex justify-content-center">
              <button
                className="google-login-btn w-100 px-3"
                title="Connect with Google"
                onClick={handleGoogleConnect}
              >
                <img
                  src={googleImg}
                  alt=""
                  className=""
                  style={{
                    width: "18px",
                    height: "18px",
                    marginRight: "10px",
                  }}
                />
                {t("opportunities.connect_with_google")}
              </button>
            </div>
          </div>
        </Box>
      ) : (
        <>
          <Paper sx={{ margin: "15px 0", padding: "0px 15px" }} elevation={4}>
            <div
              ref={containRef}
              className="ai-opportunity-editor"
              id="content-to-download"
              dangerouslySetInnerHTML={{
                __html: opportunities.data.replace(/<\/?p>/g, ""),
              }}
            />
          </Paper>
        </>
      )}
    </main>
  );
};

export default Opportunities;
